import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'moment/locale/fi';

import { TextField } from '@material-ui/core';
import { useField } from 'formik';
import moment from 'moment';
import React, { useState } from 'react';
import {
  DayPickerRangeController,
  DayPickerRangeControllerShape,
  FocusedInputShape
} from 'react-dates';
import styled from 'styled-components';

type Props = {
  name: string;
  initialValues?: {
    start_at: moment.Moment;
    end_at: moment.Moment;
  };
};

const Container = styled.div`
  width: 100%;
`;
const Absolute = styled.div`
  position: absolute;
  z-index: 1000;
`;

type momentObj = moment.Moment | null;

export default function DayrangePicker({ initialValues, name }: Props) {
  const [field, { value }] = useField(name);

  const [showPicker, setShowPicker] = useState(false);
  const [focusedInput, setFocusedInput] = useState(
    'startDate' as FocusedInputShape
  );

  const onDatesChange = ({
    startDate,
    endDate
  }: {
    startDate: momentObj;
    endDate: momentObj;
  }) => {
    field.onChange({
      target: {
        name,
        value: {
          start_at: startDate,
          end_at: endDate
        }
      }
    });
  };

  const openPicker = () => {
    setShowPicker(true);
  };

  const onOutsideClick = () => {
    setFocusedInput('startDate');
    setShowPicker(false);
  };

  const onFocusChange = (focusedInput: any) => {
    setFocusedInput(focusedInput || 'startDate');
  };

  const pickerProps: DayPickerRangeControllerShape = {
    onOutsideClick: onOutsideClick,
    onDatesChange: onDatesChange,
    onFocusChange: onFocusChange,
    firstDayOfWeek: 1,
    focusedInput,
    startDate: (field.value ? field.value.start_at : moment()) as momentObj,
    endDate: (field.value ? field.value.end_at : null) as momentObj
  };

  const valueToString = (): string | null => {
    if (!value.start_at) return '';

    const start = value.start_at ? value.start_at.format('DD.MM.YYYY') : '';
    const end = value.end_at ? value.end_at.format('DD.MM.YYYY') : '';

    return `${start} - ${end}`;
  };

  return (
    <Container>
      <TextField
        label="Tarkistettu / Huollettu"
        variant="outlined"
        placeholder="Valitse alkaen - Loppuen"
        fullWidth
        value={valueToString()}
        margin="normal"
        onClick={openPicker}
        InputLabelProps={{
          shrink: true
        }}
      ></TextField>
      {showPicker && (
        <Absolute>
          <DayPickerRangeController {...pickerProps} />
        </Absolute>
      )}
    </Container>
  );
}
